import React, { useState, useEffect, useContext } from "react";
import {
    Card,
    Row,
    Col,
    Spin,
    Tabs,
    Layout,
    theme,
    Carousel,
    Button,
} from "antd";
import { LeftOutlined, RightOutlined, FireFilled } from "@ant-design/icons";
import MenuItem from "./MenuItem";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import HotPepperIcon from '../HotPepperIcon';

const { Meta } = Card;

export default function MenuPromoSingle(promoId) {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const { promotions, promotionProducts } = useContext(PublicContext);
    const [selectedStore, setSelectedStore] = useState(1);
    const [isDragging, setIsDragging] = useState(false);
    const [selectedPromo, setSelectedPromo] = useState();

    const [menuItem, setMenuItem] = useState({
        productName: "",
        price: 0,
        description: "",
        pictureURL: "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png",
    });

    const { Header, Content, Footer } = Layout;

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const [openDrawer, setOpenDrawer] = useState(false);

    function selectMenuItem(item, promo) {
        setSelectedPromo(promo);
        setMenuItem(item);
        setOpenDrawer(true);
    }

    useEffect(() => {
        console.log("MenuPromoSingle");
        setSelectedStore(sessionStorage.getItem("selectedStore"));
        populateProductsData(selectedStore.storeId);
    }, []);

    async function populateProductsData(storeId) {
        if (localStorage.getItem("products")) {
            setProducts(JSON.parse(localStorage.getItem("products")));
            setLoading(false);
        } else {
            const response = await fetch("api/Products");
            const data = await response.json();
            setProducts(data);
            localStorage.setItem("products", JSON.stringify(data));
            //console.log(data);
            setLoading(false);
        }
    }

    function renderDrawer() {
        return (
            <MenuItem
                menuItemProp={menuItem}
                selectedPromo={selectedPromo}
                setOpenDrawer={setOpenDrawer}
            />
        );
    }

    const handleCarouselClick = () => {
        if (!isDragging) {
            // Add your onClick logic here
            //console.log("Carousel clicked!");
        }
    };

    const SlickButtonFix = ({ currentSlide, slideCount, children, ...props }) => (
        <span {...props}>{children}</span>
    );

    function renderPromotions() {
        const promotion = promotions.find(p => p.id === promoId.promoId);
        //console.log(promoId);
        //console.log(promotion);
        return (
            <div key={"promotion" + promoId.promoId}>
                {/*<h3>{promotion.promotionName}</h3>*/}
                <div className="horizontal-listing-container">
                    {/*autoplay*/}
                    {/*infinite={true}*/}
                    <Carousel
                        
                        dots={false}
                        draggable={true}
                        
                        slidesToShow={4}
                        slidesToScroll={4}
                        arrows={true}
                        //prevArrow={
                        //    <SlickButtonFix>
                        //        <Button shape="circle" className="carouselBtn" icon={<LeftOutlined className="carouselIcon" />} size={"large"} />
                        //    </SlickButtonFix>
                        //}
                        //nextArrow={
                        //    <SlickButtonFix>
                        //        <Button shape="circle" className="carouselBtn" icon={<RightOutlined className="carouselIcon" />} size={"large"} />
                        //    </SlickButtonFix>
                        //}
                        beforeChange={() => setIsDragging(true)}
                        afterChange={() => setIsDragging(false)}
                        onClick={handleCarouselClick}
                        responsive={[
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3
                                },
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                },
                            },
                        ]}
                    >
                        {renderProductsTable(promotion.id)}
                    </Carousel>
                </div>
            </div>
        );
    }

    function renderProductsTable(promoId) {
        //console.log("render product table");
        return products.map((product) => {
            if (
                promotionProducts.some(
                    (pp) =>
                        pp.promotionId === promoId &&
                        pp.buyProductCode === product.productCode
                )
            ) {
                return (
                    <Card
                        key={"promoProductCard" + product.id}
                        className="promoCarouselItem"
                        hoverable
                        height="100px"
                        bordered
                        cover={
                            <div style={{ position: "relative", overflow: "hidden" }}>
                                {renderPromotionTag(product.productCode)}
                                <img
                                    alt={product.productName}
                                    src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                    style={{ height: "auto", width: "100%" }}
                                    onError={(e) => {
                                        e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                        e.target.onerror = null;
                                    }}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "8px",
                                        left: "8px",
                                        padding: "4px",
                                        zIndex: 2,
                                    }}
                                >
                                    <HotPepperIcon value={product.spiciness} />
                                </div>
                            </div>
                        }
                        onClick={() => {
                            if (!isDragging) {
                                if (window.gtag) {
                                    var promotionName = promotions.find(p => p.id === promoId);
                                    if (promotionName) {
                                        window.gtag('event', 'OpenPromotionItem', {
                                            event_category: 'Promotion',
                                            event_label: 'OpenPromotionItem: ' + product.productName + "; promo: " + promotionName,
                                        });
                                    }
                                }
                                selectMenuItem(
                                    product,
                                    promotions.find(
                                        (p) => p.promotionType === "BuyXGetY" && p.id === promoId
                                    )
                                );
                            }
                        }}
                    >
                        <h6>{product.productName}</h6>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <p style={{ flex: "1" }}>{product.calorie}</p>
                            <p style={{ marginLeft: "8px" }}>
                                <b>{`$${product.price}`}</b>
                            </p>
                        </div>
                        {/*<p>Short descriptions</p>*/}
                    </Card>
                );
            } else {
                return null;
            }
        });
    }

    function renderPromotionTag(productCode) {
        // console.log("render promotions: " + productCode);
        // console.log(promotionProducts.find(
        //     (pp) => pp.buyProductCode === productCode
        //   ));
        if (promotionProducts.some((pp) => pp.buyProductCode === productCode)) {
            const pps = promotionProducts.find(
                (pp) => pp.buyProductCode === productCode
            );
            const ps = promotions.find((p) => p.id === pps.promotionId);
            return (
                <div
                    key={"promoTag" + pps.promotionId}
                    style={{
                        position: "absolute",
                        top: "8px",
                        left: "8px",
                        right: "8px",
                        borderRadius: "6px",
                        backgroundColor: "#38803d",
                        color: "white",
                        padding: "4px",
                        zIndex: 2
                    }}
                >
                    {ps.promotionName}
                </div>
            );
        }
    }

    function renderLoading() {
        return <Spin />;
    }

    return (
        <div>
            {loading ? renderLoading() : renderPromotions()}
            {openDrawer && renderDrawer()}
        </div>
    );
}